import wrapPageElementWithContext from "./src/helpers/wrapPageElement";
export const wrapPageElement = wrapPageElementWithContext;
